import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    cardMeta: {
      flexDirection: 'column',

      ' .ant-card-meta-title': {
        marginBottom: '0px !important'
      },

      '&& .ant-card-meta-avatar': {
        paddingRight: 0,
        marginBottom: token.marginXS
      }
    },

    divider: {
      position: 'relative',
      left: `-${token.paddingSM}px`,
      width: `calc(100% + ${token.paddingSM * 2}px)`,
      marginTop: token.marginLG,
      marginBottom: token.marginSM
    }
  }
})
